import { render, staticRenderFns } from "./file-input.vue?vue&type=template&id=06f0d4b8&scoped=true&"
import script from "./file-input.vue?vue&type=script&lang=js&"
export * from "./file-input.vue?vue&type=script&lang=js&"
import style0 from "./file-input.vue?vue&type=style&index=0&id=06f0d4b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f0d4b8",
  null
  
)

export default component.exports